import React, { useEffect, useState } from "react";
import { Alert, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Input } from "../../components";
import {
  archiveIndikator,
  bacaMasalah,
  publishIndikator,
} from "../../config/redux/action/sustainabilityAction";

const tanggalHariIni = () => new Date().toISOString().slice(0, 10);

// Satu modal dipakai untuk dua aksi tata kelola karena keduanya hanya meminta
// alasan tertulis; yang membedakan hanya wajib-tidaknya catatan dan tanggal berlaku.
function ModalPublish({ show, handleClose, indikator, mode, update }) {
  const [EffectiveFrom, setEffectiveFrom] = useState(tanggalHariIni());
  const [Catatan, setCatatan] = useState("");
  const [Error, setError] = useState([]);
  const dispatch = useDispatch();

  const publish = mode === "publish";

  useEffect(() => {
    setEffectiveFrom(tanggalHariIni());
    setCatatan("");
    setError([]);
  }, [show, indikator]);

  const kirim = () => {
    setError([]);
    if (publish && Catatan.trim() === "") {
      setError(["Catatan perubahan wajib diisi sebelum publish."]);
      return;
    }

    const aksi = publish
      ? publishIndikator(indikator.id, {
          effective_from: EffectiveFrom,
          catatan_perubahan: Catatan,
        })
      : archiveIndikator(indikator.id, Catatan);

    dispatch(aksi)
      .then(() => {
        update();
        handleClose();
      })
      .catch((err) => setError(bacaMasalah(err)));
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "16px" }}>
          {publish ? "Publish" : "Arsipkan"} {indikator?.code} v
          {indikator?.version}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {Error.length > 0 && (
          <Alert variant="danger" style={{ fontSize: "12px" }}>
            <ul className="mb-0 ps-3">
              {Error.map((val, i) => (
                <li key={i}>{val}</li>
              ))}
            </ul>
          </Alert>
        )}

        {publish ? (
          <Alert variant="warning" style={{ fontSize: "12px" }}>
            Publish akan mengarsipkan versi aktif lain dengan kode yang sama dan
            mengubah angka yang dihitung sejak tanggal berlaku. Jalankan Dry-run
            lebih dulu bila belum.
          </Alert>
        ) : (
          <Alert variant="secondary" style={{ fontSize: "12px" }}>
            Indikator yang diarsipkan berhenti dipakai pada perhitungan berikutnya.
            Data periode yang sudah terbentuk tidak ikut dihapus.
          </Alert>
        )}

        {publish && (
          <Input
            judul="Berlaku Sejak"
            type="date"
            value={EffectiveFrom}
            onChange={(e) => setEffectiveFrom(e.target.value)}
          />
        )}
        <Input
          judul={publish ? "Catatan Perubahan *" : "Alasan Pengarsipan"}
          type="textarea"
          placeholder={
            publish
              ? "Jelaskan apa yang berubah dan mengapa"
              : "Opsional, tercatat sebagai catatan perubahan"
          }
          value={Catatan}
          onChange={(e) => setCatatan(e.target.value)}
        />

        <div className="d-flex justify-content-end">
          <button className="btn btn-sm btn-secondary me-2" onClick={handleClose}>
            Batal
          </button>
          <button
            className={`btn btn-sm ${publish ? "btn-success" : "btn-dark"}`}
            onClick={kirim}
          >
            {publish ? "Publish Sekarang" : "Arsipkan"}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalPublish;
